<template>
  <div>
    <ul>
      <template v-if="reps && reps.length > 0">
      <li v-for="(user, index) in reps" :key="index"   :class="{ 'suspended-bg': user.status === 'S' }">
          {{ user.email }}
        <!-- <span v-if="type == 'all'">
          {{user.status == 'S' ? 'Suspend' : 'Active'}}
        </span> -->
          <div class="repAdmin-action">
            <custom-button
              v-if="isRootRep && user.status !== 'S'"
              title="Feature Access"
              className="featureAccess"
              iconClass="fas fa-cog"
              @onClicked="openFeatureAccess(user.email)"
            />
            <custom-button
              v-if="isRootRep && type == 'all'"
              :title="user.status == 'S' ? 'Activate' : 'Suspend'"
              :className="user.status == 'S' ? 'activate-btn' : 'suspend-btn'"
              :iconClass="user.status == 'S' ? 'fas fa-check' : 'fas fa-ban'"
              @onClicked="toggleRep(user.id, user.status)"
            />

            <custom-button
              v-if="isRootRep && user.status !== 'S'"
              title="Enable cc email"
              className="ccEmail"
              iconClass="far fa-envelope"
              @onClicked="sendEmailToParent(user.email)"
            />
            <custom-button
              v-if="isRootRep"
              title="Delete"
              className="deleteEmail"
              iconClass="far fa-trash-alt"
              @onClicked="deleteRep(user.id)"
            />
          </div>
        </li>
      </template>
      <template v-else>
        <li>
          <p class="text-center">No {{ type }} reps found.</p>
        </li>
      </template>
    </ul>
  <feature-access-modal
    :featureAccessCategories="featureAccessCategories"
    v-if="selectedEmail"
    :email="selectedEmail"
    @onCloseModal="$bvModal.hide('featureAccessModal')"
  />
</div>
</template>
<script>
import { mapGetters } from "vuex";
import Api from "@/resource/Api";
import FeatureAccessModal from "../FeatureAccessModal.vue";

export default {
  components: {
    FeatureAccessModal,
  },
  data() {
    return {
      selectedEmail: null,
      showFeatureAccessModal: false,
      featureAccessCategories: [],
    };
  },
  props: {
    reps: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ isRootRep: "rootUser" }),
  },
  mounted() {
    this.fetchFeatureAccessCategories();
  },
  methods: {
    sendEmailToParent(email) {
      this.$emit("emailSelected", email); // Emit email to parent
    },
    toggleRep(repId, status) {
      const url = `v2/activate-deactivate-agent-user`;
      const [text, value] = status == "S" ? ["Activate", 1] : ["Suspend", 0];
      this.$confirm({
        title: `${text} Admin`,
        message: `Do you want to ${text.toLowerCase()} this admin?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            let loader = this.$loading.show();
            let data = { agent_user_id: repId, activate: value };
            Api.post(url, data)
              .then((res) => {
                let response = res.data.message;
                this.$notify(response);
                this.$emit("onSuccess");
              })
              .catch((err) => {
                this.$notify(err.response.data.message, "error");
              })
              .finally(() => {
                loader.hide();
              });
          }
        },
      });
    },
    deleteRep(repId) {
      const url = `v2/delete-agent-user/${repId}`;
      this.$confirm({
        title: "Delete Rep",
        message: `Do you want to delete this rep?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            let loader = this.$loading.show();
            Api.delete(url)
              .then((res) => {
                let response = res.data.message;
                this.$notify(response);
                this.$emit("onSuccess");
              })
              .catch((err) => {
                this.$notify(err.response.data.message, "error");
              })
              .finally(() => {
                loader.hide();
              });
          }
        },
      });
    },
    fetchFeatureAccessCategories() {
      const url = `v2/admin-feature-categories`;
      let loader = this.$loading.show();
      Api.get(url)
        .then((res) => {
          console.log(res);
          this.featureAccessCategories = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    openFeatureAccess(email) {
      this.selectedEmail = email;
      this.$bvModal.show('featureAccessModal');
    },
  },
};
</script>

<style>
.ccEmail {
  background-color: #0080ff !important;
}
.ccEmail:hover {
  background-color: #0080ef !important;
  color: #fff;
}

.featureAccess {
  background-color: #19927c !important;
}
.featureAccess:hover {
  background-color: #19927c !important;
  color: #fff;
}

.suspended-bg {
  background-color: #ff4b4b32 !important; 
}
</style>